module.exports = __webpack_public_path__ + "static/media/42.965b2e79.jpg";